import axios from 'axios';
import { Toast, Dialog } from 'vant';

const service = axios.create({
  timeout: 9000,
});

// 拦截request请求
service.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error),
);

service.interceptors.response.use(
  (response) => {
    if (response.status !== 200) {
      Toast.fail('接口异常...');
    }
    const res = response.data;
    return res;
  },
  (error) => {
    console.log(error);
    Dialog.alert({
      message: error.message,
    });
  },
);

export default service;
